import styled from "styled-components"

import { useGetReferralAgentReferralStatsQuery } from "store/api/referralsApi"
import { ApiTypes } from "types"

const statCards: { title: string; key: keyof ApiTypes.Model.ReferralAgentReferralStats; accent: string }[] = [
  { title: "Total Referrals", key: "total", accent: "var(--surface-inverse)" },
  { title: "Installed", key: "installed", accent: "var(--status-success)" },
  { title: "In progress", key: "in_progress", accent: "var(--status-warning)" },
  { title: "In review", key: "in_review", accent: "var(--status-info)" },
]

const CardsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
`

// the colored cap peeks out above the white card, following the outer radius
const CardShell = styled.div<{ $accent: string }>`
  flex: 1 0 0;
  min-width: min(220px, 100%);
  padding-top: 6px;
  border-radius: 16px;
  background: ${({ $accent }) => $accent};
`

const CardBody = styled.div`
  padding: 16px 20px;
  border-radius: 12px;
  background: var(--surface-1);
`

const CardTitle = styled.div`
  font-size: 14px;
  color: var(--text-primary);
`

const CardValue = styled.div`
  margin-top: 4px;
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
`

export const ReferralStatsCards = () => {
  const { data } = useGetReferralAgentReferralStatsQuery()
  const stats = data?.data

  return (
    <CardsRow>
      {statCards.map(({ title, key, accent }) => (
        <CardShell key={key} $accent={accent}>
          <CardBody>
            <CardTitle>{title}</CardTitle>
            <CardValue>{stats ? stats[key] : "–"}</CardValue>
          </CardBody>
        </CardShell>
      ))}
    </CardsRow>
  )
}
